import React from 'react';
import classNames from 'classnames';
import { Form, Checkbox } from 'semantic-ui-react';
import SystemOnlyBadge from '../../../../components/common/SystemOnlyBadge';

export default class WizardRadioField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hovering: false };
  }

  handleHover() {
    this.setState({ hovering: !this.state.hovering });
  }

  onCheckboxChange = () => {
    if (this.props.onChange) {
      this.props.onChange(this.props.value);
    }
  };

  render() {
    const fieldClassNames = classNames({
      checked: this.props.checked,
      hovered: this.state.hovering
    });

    return (
      <Form.Field
        onMouseEnter={this.handleHover.bind(this)}
        onMouseLeave={this.handleHover.bind(this)}
        className={fieldClassNames}
        onClick={this.onCheckboxChange}
        style={{ cursor: 'pointer' }}
      >
        <Checkbox
          label={this.props.label}
          name={`${this.props.value}wizardRadio`}
          value={this.props.value}
          checked={this.props.checked}
          onChange={this.onCheckboxChange}
          radio
        />
        {/* A system-only option carries the badge beside the radio; the badge is help, not a selection. */}
        {this.props.systemOnly && (
          <span
            role="presentation"
            onClick={(event) => event.stopPropagation()}
          >
            <SystemOnlyBadge />
          </span>
        )}
        {this.props.children}
      </Form.Field>
    );
  }
}
